<template>
  <div class="parentDiv">
    <!-- use v-flex if gustong horizontal -->
    <b-card :img-src="illus.link" class="sortableObj my-2" v-for="illus in illustrations" :key="illus.id">
      <!-- <p>{{page.pagenum}}</p> -->
      <b-icon-trash-fill v-on:click="deleteIllusHandler(illus.id)"></b-icon-trash-fill>
    </b-card>
  </div>
</template>

<script>
import { db, storage } from '@/firebase/init'
import { BIconTrashFill } from 'bootstrap-vue'

export default {
  name: 'Manage',
  components: {
    BIconTrashFill
  },

  data(){
    return{
      illustrations: []
    }
  },
  methods: {
    deleteIllusHandler(illus_id){
      this.deleteIllus(illus_id);
    },
    
    deleteIllus(illus_id){

      db.collection("illustrations").doc(illus_id).delete().then(()=>{
        var storageRef = storage.ref()
        var mountainsRef = storageRef.child(`illustrations/${illus_id}`)

        mountainsRef.listAll().then((result) =>{
          result.items.forEach((file)=>{
            file.delete()
            // console.log('file deleted')
          })
        })
      }).then(()=>{
        window.location.href = window.location.origin + '/#/gallery'
        })      
    },

    queryIllus(){
      db.collection('illustrations')
        .orderBy("dateAdded", "asc")
        .get()
        .then(docs =>{
          // console.log(docs)
          docs.forEach(doc => {
            this.illustrations.push(
              {
                id: doc.id,
                link: doc.data().link
                })
          });
        })
        .catch(err=>{
          throw err;
        })
    },
  },
  created(){
    this.queryIllus();
  }
}
</script>

<style scoped>
  .parentDiv{
    padding: 5%;
    background-color: wheat;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    border-radius: 5px;
    margin-top: 25px;
  }
  .sortableObj{
    background-color: white;
    margin: auto 25%;
    border: 1px solid black;  
  }
</style>
